import type { LocationField } from "./CreateSegment.Constants";

// Placeholder until the backend exposes the tenant's cities and provinces.
export const LOCATION_OPTIONS_MOCK: Record<LocationField, string[]> = {
  city: [
    "Lahore",
    "Karachi",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Multan",
    "Peshawar",
    "Quetta",
    "Sialkot",
    "Hyderabad",
  ],
  province: [
    "Punjab",
    "Sindh",
    "Khyber Pakhtunkhwa",
    "Balochistan",
    "Islamabad Capital Territory",
    "Gilgit-Baltistan",
    "Azad Kashmir",
  ],
};
